module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 9
// module chunks = 0